import { motion } from "framer-motion";
import { SectionHeader } from "@/components/SectionHeader";
import { EDUCATION } from "@/data/portfolio";

export const Education = () => {
  return (
    <section
      id="education"
      data-testid="education-section"
      className="px-6 md:px-12 lg:px-24 py-24 md:py-32 bg-white"
    >
      <SectionHeader
        eyebrow="01 / Education & Training"
        title="Learning On & Off The Pitch"
        description="Balancing school with the daily grind of academy training — the foundations that shape a young footballer."
        testId="education-header"
      />

      <div className="mt-16 md:mt-24 grid grid-cols-1 lg:grid-cols-12 gap-x-12">
        <div className="lg:col-span-2 hidden lg:block">
          <div className="sticky top-28 text-[11px] font-semibold uppercase tracking-[0.3em] text-neutral-400">
            Timeline
          </div>
        </div>

        <ol className="lg:col-span-10 relative border-l border-neutral-200 pl-8 md:pl-12 space-y-14 md:space-y-16">
          {EDUCATION.map((e, idx) => (
            <motion.li
              key={e.degree}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: idx * 0.05, ease: "easeOut" }}
              className="relative"
              data-testid={`education-item-${idx}`}
            >
              <span className="absolute -left-[37px] md:-left-[49px] top-2 w-2.5 h-2.5 bg-[#e63946] rounded-full" />
              <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8">
                <div className="md:col-span-3">
                  <div className="text-xs font-semibold uppercase tracking-[0.25em] text-neutral-500">
                    {e.years}
                  </div>
                </div>
                <div className="md:col-span-9">
                  <h3 className="font-display text-2xl md:text-3xl font-bold tracking-tight">
                    {e.degree}
                  </h3>
                  <p className="mt-1 text-sm font-semibold uppercase tracking-wider text-neutral-700">
                    {e.institution}
                  </p>
                  <p className="mt-4 text-base text-neutral-600 leading-relaxed max-w-2xl">
                    {e.description}
                  </p>
                </div>
              </div>
            </motion.li>
          ))}
        </ol>
      </div>
    </section>
  );
};
